module.exports = __webpack_public_path__ + "static/img/ny-03-DOWNLOAD.450165b0.jpg";